import { inject, Injectable } from '@angular/core';
import { PermissionEnum } from '../../enums/PermissionEnum';
import { Menus } from '../../interfaces/Menus';
import { PermissionService } from '../permission/permission.service';

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private permissionService: PermissionService = inject(PermissionService);

  private menus: Menus = {
    regular: [
      {
        id: 1,
        description: 'Dashboard',
        icon: 'dashboard',
        route: '/app/dashboard',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.DASHBOARD_VIEW_MENU
        )}`,
      },
      {
        id: 10,
        description: 'Projetos',
        icon: 'folder_open',
        route: '/app/projetos',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.PROJECT_VIEW_MENU
        )}`,
      },
      {
        id: 2,
        description: 'Profissionais',
        icon: 'work',
        route: '/app/professionals',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.PEOPLE_VIEW_MENU
        )}`,
      },
      {
        id: 3,
        description: 'Alunos',
        icon: 'sentiment_satisfied_alt',
        route: '/app/students',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.STUDENT_VIEW_MENU
        )}`,
      },
      {
        id: 4,
        description: 'Núcleos',
        icon: 'center_focus_weak',
        route: '/app/cores',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.CORE_VIEW_MENU
        )}`,
      },
      {
        id: 5,
        description: 'Turmas',
        icon: 'school',
        route: '/app/classes',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.CLASS_VIEW_MENU
        )}`,
      },
      {
        id: 6,
        description: 'Parceiros',
        icon: 'handshake',
        route: '/app/partners',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.PARTNER_VIEW_MENU
        )}`,
      },
      {
        id: 7,
        description: 'Frequência',
        icon: 'check_box',
        route: '/app/frequencies',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.FREQUENCY_VIEW_MENU
        )}`,
      },
      {
        id: 8,
        description: 'Relatórios',
        icon: 'description',
        route: '/app/reports',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.REPORT_VIEW_MENU
        )}`
      },
      {
        id: 9,
        description: 'Relatório de Supervisão',
        icon: 'analytics',
        route: '/app/supervisor-reports',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.REPORT_SUPERVISOR_VIEW_MENU
        )}`
      },
    ],
    settings: [
      {
        id: 1,
        description: 'Permissões',
        icon: 'key',
        route: '/app/permissions',
        permission: `${this.permissionService.getPermissionDescription(
          PermissionEnum.PROFILE_VIEW_MENU
        )}`
      },
    ],
  };

  private updatedMenus: Menus = {
    regular: [],
    settings: [],
  };

  constructor() {}

  getMenus(): Menus {
    this.updatedMenus.regular = this.menus.regular.filter((menu) => {
      return (
        !menu.permission ||
        this.permissionService
          .getUserPermissions()
          .some((permission) => menu.permission === permission)
      );
    });

    this.updatedMenus.settings = this.menus.settings.filter((menu) => {
      return (
        !menu.permission ||
        this.permissionService
          .getUserPermissions()
          .some((permission) => menu.permission === permission)
      );
    });

    return this.updatedMenus;
  }

  getFirstMenuUserCanAccess(): string {
    const userPermissions = this.permissionService
      .getUserPermissions()
      .filter((permission) => permission.includes('VIEW_MENU'));

    if (userPermissions.length === 0) {
      return '/app/dashboard';
    }

    const allMenus = [...this.menus.regular, ...this.menus.settings];

    const menuWithPermissions = allMenus.filter((menu) => menu.permission);

    const firstMenu = menuWithPermissions.find((menu) => {
      return menu.permission
        ? userPermissions.some((permission) =>
            menu.permission === permission
          )
        : true;
    });

    return firstMenu ? firstMenu.route : '/app/dashboard';
  }
}
